module.exports = __webpack_public_path__ + "static/molecule2-1b8aa6b675aa1acfe3235a6233c22f44.jpg";